// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToTop_root__2yr38","materialOverride":"BackToTop_materialOverride__2p8xq"};